export default __webpack_public_path__ + "static/media/teamwork.f77af823.jpg";